import { getMetaContent } from './../app/utils';

export const getThemeImages = () => ({
  logoImgSrc: getMetaContent('logo-img'),
  heroImgSrc: getMetaContent('hero-img'),
  doneImgSrc: getMetaContent('done-img'),
});
